import { render, staticRenderFns } from "./ActivePrices.vue?vue&type=template&id=363be941&"
import script from "./ActivePrices.vue?vue&type=script&lang=js&"
export * from "./ActivePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports